module.exports = __webpack_public_path__ + "img/intalentpool.1d1e3dc8.svg";